import { type InfiniteData, useInfiniteQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { blogKeys } from "./keys";

type BlogPageResponse = Awaited<ReturnType<typeof Api.Blog.getApiBlog>>;

/** Подгружает опубликованные статьи небольшими страницами. */
export const useListBlogArticles = () => {
	const query = useInfiniteQuery<
		BlogPageResponse,
		Error,
		InfiniteData<BlogPageResponse>,
		typeof blogKeys.list,
		number
	>({
		getNextPageParam: (lastPage, pages) => {
			if (lastPage.data?.hasMore !== true) return undefined;
			return pages.reduce((offset, page) => offset + (page.data?.items.length ?? 0), 0);
		},
		initialPageParam: 0,
		queryFn: ({ pageParam }) => Api.Blog.getApiBlog({ offset: pageParam }),
		queryKey: blogKeys.list,
	});
	return {
		data: query.data?.pages.flatMap((page) => page.data?.items ?? []) ?? [],
		execute: async () => query.refetch(),
		hasMore: query.hasNextPage,
		isLoadingMore: query.isFetchingNextPage,
		isPending: query.isPending,
		loadMore: async () => query.fetchNextPage(),
	};
};
